import { gql } from '@apollo/client';

const getServiceAddOnsQuery = () => {

  const ServiceAddOnsQuery = gql`
    query Install($itemId: String!, $storeId: String!) {
      serviceAddOns(itemId: $itemId, storeId: $storeId) {
        sellFurnishInstall {
          installationServiceType
          installationProgramCategory
          installationContactNumber
          dualPathSku
        }
        proReferrals {
          serviceIdentifier
          serviceName
          serviceDisplayName
          assemblyCategory
          startingPrice
          available
          providers {
            provider
          }
        }
        attachLabor {
          storeId
          installSkus {
            installSku
            installSkuDepartmentNumber
            installSkuClass
            installSkuSubClass
            serviceType
            eligibility {
              isInstallAvailable
              vendorNumber
              skuStatusCode
            }
            installRetailPrice {
              price
            }
            doItForMe {
              title
              subTitle
              timeEstimate
              priceIncludes {
                sequenceNumber
                shortText
                longText
              }
              priceNotIncludes {
                sequenceNumber
                shortText
                longText
              }
              marketing {
                sequenceNumber
                longText
              }
              installProcess {
                sequenceNumber
                longText
              }
            }
          }
          doItYourself {
            itemId
            projectTitle
            projectSubTitle
            projectURL
            projectSkillLevel
            projectTimeEstimate
            projectSteps
            tools {
              title
            }
            materials {
              title
            }
          }
        }
      }
    }
`;
  return ServiceAddOnsQuery;
};

export default getServiceAddOnsQuery;
